import {observer} from "mobx-react";
import React from "react";
import themeState from "../state/themeState";
import experimentState, {ApplicationState} from "../state/experimentState";
import backend from "../backend";
import photo_blank from '../images/photo_blank.png'

class Phase1LabelValue extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            initValue: '',
            vertical: (this.props.vertical === "true"),
        }
    }

    onChange(evt) {
        let state = this.state
        if (this.props.type === "checkbox") {
            state.value = !!evt.target.checked
        } else if (this.props.type === "choice") {
            state.value = parseInt(evt.target.id)
        } else {
            state.value = evt.target.value
        }
        this.setState(state)
        this.props.onHandleChange(this.props.id, state.value)
    }

    render() {
        let flexFlow = (this.state.vertical) ? "column" : "row"

        let errorStyle = {}
        if (this.props.error && this.props.initValue === this.state.value) {
            errorStyle = {
                border: "2px solid red",
            }
        }
        let inputTag = null;
        if (this.props.type === "choice") {
            inputTag = <fieldset style={{...errorStyle}}
                              onChange={this.onChange.bind(this)}>
                {this.props.choices.map((choice,idx) => {
                    return <div key={idx} ><input type="radio" id={idx} name={this.props.id}/><label>{choice}</label></div>
                })}
            </fieldset>
        } else {
            inputTag = <input type={this.props.type} value={this.state.value} id={this.props.id}
                              placeholder={this.props.placeholder}
                              onChange={this.onChange.bind(this)}
                              checked={this.props.type === "checkbox" ? this.state.value : undefined}
                              style={{...errorStyle}}
            />
        }
        return <div style={{display: "flex", flexFlow: flexFlow, gap: "4px", justifyContent: "space-between"}}>
            <label>{this.props.label}:</label>
            {inputTag}
        </div>

    }

}

const Phase1Screen = observer(
    class extends React.Component {

        constructor(props) {
            super(props);
            let state = this.initialState()
            for (let i = 0; i < experimentState.fields.length; i += 1) {
                let f = experimentState.fields[i]
                state[f.id] = {
                    error: false,
                    value: "",
                    initValue: "",
                }
            }
            this.state = state
        }


        initialState() {
            return {
                once: true
            }
        }

        handleChange(key, val) {
            let state = this.state
            state[key].value = val
            this.setState(state)
        }

        onSubmit(evt) {
            let anyError = false;
            let state = this.state
            for (let i = 0; i < experimentState.fields.length; i += 1) {
                let f = experimentState.fields[i]
                this.state[f.id].initValue = this.state[f.id].value
                // console.log(`${f.id} - ${this.state[f.id].value}`)
                let validateFn = (f.validateFn !== undefined) ? f.validateFn : (val) => {
                    return true
                }
                state[f.id].error = !validateFn(this.state[f.id].value)
                if (state[f.id].error) {
                    anyError = true;
                }
            }
            state.anyError = anyError
            this.setState(state)
            if (!anyError) {
                let realProfile = {
                }
                experimentState.fields.forEach(({id}) => {
                    realProfile[id] = this.state[id].value
                    // console.log(`${id} - ${realProfile[id]}`)
                })
                realProfile.photo = photo_blank
                experimentState.setRealProfile(
                    realProfile
                )
                if (!experimentState.experimentParams.lie) {
                    experimentState.setUseProfile(realProfile)
                }
                experimentState.deleteEvents()
                backend.actionSendMessage(experimentState.useProfile.firstname, "Finished fase 1")

                let questions = experimentState.renderQuestionsShuffleWithSeed(experimentState.experimentParams.shuffle_seed)
                let thirdPartyQuestions = experimentState.renderSimpleShortQuestionsThirdPerson(experimentState.experimentParams.shuffle_seed)
                experimentState.setQuestions(questions)
                experimentState.setThirdPartyQuestions(thirdPartyQuestions)


                if (this.state.once === false) {
                    state.once = true
                    this.setState(state)
                } else {
                    experimentState.setApplicationState(this.props.nextPhase)
                }

            }
            evt.preventDefault()
        }


        render() {
            return <div>
                <header className="header" style={{backgroundColor: themeState.colour_primary}}><h1>Wie bent u?</h1>
                </header>
                <section style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    alignContent: "center",
                }}>
                    <form onSubmit={this.onSubmit.bind(this)} style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        padding: "10% 10% 10% 10%",
                        border: "4px",
                        borderStyle: "solid",
                        borderColor: themeState.colour_primary,
                        borderRadius: "4px",
                    }}>
                        {experimentState.fields.filter(({hidden}, idx) => !hidden).map(({
                                                                                            type,
                                                                                            label,
                                                                                            phase1Label,
                                                                                            horizontal,
                                                                                            id,
                                                                                            placeholder,
                                                                                            choices
                                                                                        }, idx) => {
                            return <Phase1LabelValue
                                key={id}
                                label={phase1Label ? phase1Label : label}
                                horizontal={horizontal}
                                type={type}
                                id={id}
                                placeholder={placeholder}
                                error={this.state[id].error}
                                initValue={this.state[id].initValue}
                                choices={choices}
                                onHandleChange={this.handleChange.bind(this)}
                            />
                        })}

                    </form>
                    <button onClick={this.onSubmit.bind(this)}
                            style={{backgroundColor: themeState.colour_primary, padding: "16px"}}>Volgende
                    </button>

                    {/*<div>Dit zijn alle vragen:</div>*/}
                    {/*{experimentState.loaded ?*/}
                    {/*<ol>*/}
                    {/*    <li>Training</li>*/}
                    {/*    {experimentState.questions.map(([qid,rid,text,shortness,positive,cr],idx) => {return <div>{idx} - {qid} - {shortness} - {text} -> Antwoord:{(positive)? "Ja" : "Nee"} - Challenge:{cr.challenge? "Ja": "Nee"}</div>})}*/}
                    {/*</ol> : <div>Experiment is niet geladen. Weet je zeker dat je bent verbonden?</div>}*/}

                </section>
            </div>
        }
    }
)

export default Phase1Screen